import RequestHelper from '../helpers/request-helper';
import HotReward from '../helpers/hot-reward';

const requestHelper = new RequestHelper();
const rewardCarouselItemTemplate = require('../twigs/rewardCarouselItemTemplate.twig');

export default class Blocks {
    constructor() {
        this.state = {
            hotReward: null,
            isShelter: FreshStep.isShelter,
            rewards: [],
        };
    }

    static renderPanelFAQ() {
        const $accordianListItemQuestion = $('.accordion-list .item__question');
        $accordianListItemQuestion.on('click', (e) => {
            // console.log('void')
            // console.log($accordianListItemQuestion);
            e.preventDefault();
            $(e.currentTarget).closest('li').find('.item__answer').not(':animated').slideToggle();
            $(e.currentTarget).find('.arrow-icon').toggleClass('active');
        });


        $accordianListItemQuestion.on('click', (e) => {
            if (e.key === 'enter') {
                // console.log('enter')
                // console.log($accordianListItemQuestion);
                e.preventDefault();
                $(e.currentTarget).closest('li').find('.item__answer').not(':animated').slideToggle();
                $(e.currentTarget).find('.arrow-icon').toggleClass('active');
            }
        });
    }

    async renderPanelRewards() {
        await this.fetchHotReward();
    }

    async fetchHotReward() {
        this.state.hotReward = await HotReward.fetchHotReward();
        this.fetchRewardsCatalog();
    }

    fetchRewardsCatalog() {
        requestHelper.makeRequest('/wp-json/electro/v1/paw-points/rewards-catalog', 'GET').then((response) => {
            if (response.data.items.length > 0) {
                // Is this a shelter?
                if (this.state.isShelter) {
                    const rewards = response.data.items;

                    // Remove all except for Shelter Exclusives
                    $.each(rewards, (index, value) => {
                        if (value.categories.includes('Shelter Exclusive') !== true) {
                            delete rewards[index];
                        }
                    });

                    // Remove empty keys from Object
                    const shelterRewards = Object.keys(rewards)
                        .filter((k) => rewards[k] != null)
                        .reduce((a, k) => ({ ...a, [k]: rewards[k] }), {});
                    this.state.categories = response.data.categories;

                    // Re-Key the Array and add to state
                    $.each(shelterRewards, (index, value) => {
                        this.state.rewards.push(value);
                    });
                    this.populateCarousel();
                } else {
                    const rewards = response.data.items;

                    // Remove all Shelter Exclusives
                    $.each(rewards, (index, value) => {
                        if (value.categories.includes('Shelter Exclusive') === true) {
                            delete rewards[index];
                        }
                    });

                    // Remove empty keys from Object
                    const consumerRewards = Object.keys(rewards)
                        .filter((k) => rewards[k] != null)
                        .reduce((a, k) => ({ ...a, [k]: rewards[k] }), {});
                    this.state.categories = response.data.categories;

                    // Re-Key the Array and add to state
                    $.each(consumerRewards, (index, value) => {
                        this.state.rewards.push(value);
                    });

                    this.populateCarousel();
                }
            }
        });
    }

    populateCarousel() {
        const { rewards } = this.state;

        // Default sorting by asc cost
        rewards.sort((a, b) => {
            const a1 = a.price;
            const b1 = b.price;
            if (a1 === b1) return 0;
            return a1 > b1 ? 1 : -1;
        });

        $('#redeem-points-for-rewards .slider--recommended-rewards').append(
            rewardCarouselItemTemplate({
                rewards,
                hotReward: this.state.hotReward,
                isShelter: this.state.isShelter,
            })
        );

        Blocks.initRewardSlider();
    }

    static initRewardSlider() {
        $('.slider--recommended-rewards').slick({
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 6,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 875,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        arrow: false,
                    },
                },
            ],
        });

        // Custom carousel nav
        $('.js-carousel-prev').click((e) => {
            e.preventDefault();
            $('.slider--recommended-rewards').slick('slickPrev');
        });

        $('.js-carousel-next').click((e) => {
            e.preventDefault();
            $('.slider--recommended-rewards').slick('slickNext');
        });
    }
}
